import React, { useState,useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";

import { 
  addCompanyService, 
  fetchCompanyTypes as fetchCompanyTypesService, 
  fetchCurrencies as fetchCurrenciesService, 
  fetchIndustries as fetchIndustriesService, 
  fetchFrequencies as fetchFrequenciesService
} from 'services/modules/idp/company';
import { fetchCloudTypes as fetchCloudTypesService} from 'services/modules/vapt/alert';

import { 
  Autocomplete,
  Card, 
  CardHeader, 
  Divider, 
  Button, 
  CardContent,
  Checkbox,
  CircularProgress,
  FormHelperText, 
  MenuItem, 
  Grid, 
  Select, 
  FormControl, 
  InputLabel, 
  TextField, 
  Radio, 
  RadioGroup,
  FormGroup,
  FormControlLabel, 
  FormLabel,
  IconButton
} from '@mui/material';

import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import DeleteIcon from '@mui/icons-material/Delete';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { CountryDropdown } from 'react-country-region-selector';
import { useNotification } from 'config/Notification';
import { fetchDimensionsVAPT as fetchDimensionsVAPTService} from 'services/modules/vapt/data';
import { getSOCGroupValidation } from 'services/modules/soc/agent';

const Addcompany = () => {

  // Redux dispatch
  const dispatch = useDispatch();

  // React router
  const navigate = useNavigate();

  // Notification
  const { openNotification } = useNotification();

  // Redux selectors
  const industriesContainer = useSelector((state) => state.company.industries);
  const frequenciesContainer = useSelector((state) => state.company.frequencies);
  const currenciesContainer = useSelector(state => state.company.currencies);
  const companyTypesContainer = useSelector(state => state.company.companytypes);
  const authenticatedUserContainer = useSelector(state => state.auth.user);
  const heatmapContainer = authenticatedUserContainer.company.heatmap || '';
  const pptReportContainer= authenticatedUserContainer.company.ppt_report;
  const cloudTypesContainer = useSelector((state)=> state.vaptAlert.cloudtypes);
  const applicationsContainer = useSelector((state)=> state.auth.user.company.applications);
  const categoriesContainer = useSelector((state)=>state.auth.user.company.category);
  const vaptDimensionsContainer = useSelector(state => state.vaptData.vaptDimensions);
  
  // State variables
  const [phone, setPhone] = useState("");
  const [nacecode, setNaceCode] = useState("NACE");
  const [countryName, setCountryName] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [employeError, setEmployeError] = useState("");
  const [errormessage, setErrorMessage] = useState("")
  const [dynamicFields, setDynamicFields] = useState(['']);
  const [dynamicFieldsNetwork, setDynamicFieldsNetwork] = useState(['']);
  const [loading,setLoading] = useState(false)
  const [formData, setFormData] = useState({
    ppt_report: pptReportContainer,
    name: '',
    domain: '',
    contactname: '',
    email: '',
    companytype: '',
    country: '',
    location: {
      name: '',
      coords: [0, 0],
    },
    locate: '',
    employesize: '',
    supplier_types: ["Insignificant", "Routine", "Preferred", "Strategic"],
    supplier_type: '',
    currency: '',
    industry: '',
    reportFrequency: '',
    cloudtypes: [],
    category:[],
    webapplications: [],
    network_locations: [],
    mobiletypes:[],
    mobile_code: '91',
    mobile_digits: '',
    mobile: {
      code: '',
      digits: ''
    }
  });
  
  // useEffect dispatches the actions and updates the store 
  useEffect(() => {
    dispatch(fetchCompanyTypesService());
    dispatch(fetchCurrenciesService());
    dispatch(fetchIndustriesService());
    dispatch(fetchFrequenciesService());
    dispatch(fetchCloudTypesService())
    dispatch(fetchDimensionsVAPTService({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  // This method handles change in autocomplete fields
  const handleAutocompleteChange = (event, newValue) => {
    const selectedId = newValue ? newValue.id : '';
    handleInputChange({ target: { name: 'industry', value: selectedId } });
  };

  // Handles changes in form input fields
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "mobile_digits" && !/^\d+$/.test(value)) {
      setPhoneError("Only Digits");
    } else {
      setPhoneError("");
    }
    if (name === "employesize" && (!/^\d+$/.test(value)  || parseInt(value) === 0)) {
      setEmployeError("Employee size must be a valid number");
    } else {
      setEmployeError("");
    }
    if (name === "email" && !/^\S+@\S+\.\S+$/.test(value)) {
      setEmailError("Invalid email");
    } else {
      setEmailError("");
    }
    if (type === 'checkbox' && name === 'cloudtypes') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        cloudtypes: checked
          ? [...prevFormData.cloudtypes, value]
          : prevFormData.cloudtypes.filter((appId) => appId !== value),
      }));
    }
    else
    {
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
   }
  };

  // This method displays the form error if the form validation is not satisfied
  const handleErrors = (fieldName) => {
    setFormErrors((prevformErrors) => ({
      ...prevformErrors,
      [fieldName]: true,
    }));
  };

 // Handle the changes for mobiletypes
 const handleMobileTypesChange = (e) =>{
   const {  value,  checked } = e.target;
    setFormData((prevFormData) => ({
        ...prevFormData,
        mobiletypes: checked
          ? [...prevFormData.mobiletypes, value]
          : prevFormData.mobiletypes.filter((type) => type !== value),
      }));
  }

  // Handles adding a new dynamic field for web applications
  const handleAddField = () => {
    setDynamicFields([...dynamicFields, { fieldName: '', }]);
  };
  
  // Handles adding a new dynamic field for network
  const handleAddFieldNetwork = () => {
    setDynamicFieldsNetwork([...dynamicFieldsNetwork, { fieldName: '', }]);
  };

  // Handles changing a dynamic field for webapplications
  const handleDynamicFieldChange = (index,  value) => {
    const updatedFields = [...dynamicFields];
    updatedFields[index] = value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      webapplications : updatedFields
    })) ;
    setDynamicFields(updatedFields);
  };
 
  // Handles changing a dynamic field for network
  const handleDynamicFieldChangeNetwork = (index,  value) => {
    const updatedFields = [...dynamicFieldsNetwork];
    updatedFields[index] = value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      network_locations : updatedFields
    })) ;
    setDynamicFieldsNetwork(updatedFields);
  };
  
// Handles removing a dynamic field for web applications
  const handleRemoveField = (index) => {
    const updatedFields = [...dynamicFields];
    updatedFields.splice(index, 1);
    setDynamicFields(updatedFields);
    setFormData((prevFormData)=>({
      ...prevFormData,
      webapplications : updatedFields
    }))
  };

  // Handles removing a dynamic field for Network
  const handleRemoveFieldNetwork = (index) => {
    const updatedFields = [...dynamicFieldsNetwork];
    updatedFields.splice(index, 1);
    setDynamicFieldsNetwork(updatedFields);
    setFormData((prevFormData)=>({
      ...prevFormData,
      network_locations : updatedFields
    }))
  };

  const createSlugToIdMap = (items, idKey = '_id') => {
    return items?.reduce((map, item) => {
      map[item.slug] = item[idKey];
      return map;
    }, {});
  };

  const categorySlugToIdMap = createSlugToIdMap(vaptDimensionsContainer);
 
  // Handles the form submission 
  const handleSubmit = async(e) => {
    try
    {
    e.preventDefault();
    setLoading(true);
    if(applicationsContainer?.some(app=>app.slug==="vapt") &&  categoriesContainer?.length === 0){
      openNotification('Atleast one category must be selected','error')
      return;
    }
    if(applicationsContainer?.some(app=>app.slug==="vapt") && categoriesContainer?.includes(categorySlugToIdMap['web-application']) && formData.webapplications.length ===0){
      openNotification('Please fill the Web Applications field','error');
      return;
    }
    if(applicationsContainer?.some(app=>app.slug==="vapt") && categoriesContainer?.includes(categorySlugToIdMap['network']) && formData.network_locations.length ===0){
      openNotification('Please fill the Network Locations field','error');
      return;
    }
    if(applicationsContainer?.some(app=>app.slug==="vapt") && categoriesContainer?.includes(categorySlugToIdMap['mobile']) && formData.mobiletypes.length ===0){
      openNotification('Atleast one mobile type must be selected','error');
      return;
    }
    if(applicationsContainer?.some(app=>app.slug==="vapt") && categoriesContainer?.includes(categorySlugToIdMap['cloud']) && formData.cloudtypes?.length ===0){
      openNotification('Atleast one cloud type must be selected','error');
      return;
    }
    if(applicationsContainer?.some(app=>app.slug==="soc") && formData.soc_group !== '' && formData.soc_env !== ''){
      let response = await getSOCGroupValidation({group:formData.soc_group,soc_env:formData.soc_env});
        if(!response?.data)
           {
            openNotification(response.message,'error');
            return;
          }     
        }
    const updatedFormData = { ...formData };
    delete updatedFormData.supplier_types;
    if (heatmapContainer === "false" || heatmapContainer === '')
      delete updatedFormData.supplier_type;
    updatedFormData.mobile = {
      code: phone ? phone : formData.mobile_code,
      digits: formData.mobile_digits,
    };
    delete updatedFormData.mobile_code;
    delete updatedFormData.mobile_digits;
    updatedFormData.location = {
      name: updatedFormData.locate,
      coords: [0, 0],
    };
    delete updatedFormData.locate;
    updatedFormData.country = countryName;
    const emptyFields = Object.entries(updatedFormData)
      .filter(([name, value]) => value === '')
      .map(([name]) => name);
    if(categoriesContainer?.length>0)
      updatedFormData.category = categoriesContainer;
    if (emptyFields.length > 0) {
      const fieldNames = emptyFields.join(', ');
      setErrorMessage(`Please fill in the required fields: ${fieldNames}`);
      return;
    } else
      setErrorMessage('');
      updatedFormData.applicationWeightages = authenticatedUserContainer?.company?.applicationWeightages
      ? authenticatedUserContainer.company.applicationWeightages.map(({ application, weightage }) => ({
          application: application.id,
          weightage
        }))
      : [];
      updatedFormData.network_locations = formData?.network_locations?.map((app)=>app.trim());
      updatedFormData.webapplications = formData?.webapplications?.map((app)=>app.trim());
      let response=await addCompanyService(updatedFormData);
      if(response?.status === 200 || response?.status === 201)
      {
      setErrorMessage('')
      openNotification('Company added successfully','success')
      navigate('/companies')
      }
      else
      {
        setErrorMessage(response)
      }
  }
  catch(error)
  {

  }
  finally{
    setLoading(false)
  }
  };
  return (
    <div className="position-relative">
      {loading && (
        <div className="card-loader-overlay">
          <CircularProgress size={60} />
        </div>
      )}
    <div className="card-container">
      <Card className="card">
        <CardHeader
          title={
            <React.Fragment>
              <div className='card-head'>
                <div className="deflex-head">
                  <img src="/assets/partners.svg" alt="icon" className="card-icon" />
                  <label className='label'> Partners<ArrowRightIcon className='header-size' /> Add New</label>
                </div>
                <div>
                  <Button variant="contained" className="back font" onClick={()=>window.history.back()}>Back</Button>
                </div>
              </div>
            </React.Fragment>
          }
        />
        <Divider className="divider" />
        <CardContent className="center-card">
          <Card className="user-card row company-screen-bg">
            <div className="row col-lg-12">
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md ">
                <FormControl fullWidth>
                  <TextField 
                    variant="outlined" 
                    fullWidth 
                    name="name" 
                    label="Company Name"
                    value={formData.name} 
                    onChange={handleInputChange}  
                    onBlur={() => handleErrors('name')}
                    error={formData.name === '' && formErrors.name}
                    helperText={formData.name === '' && formErrors.name ? 'Field is required' : ''}
                  />
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md">
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name="domain"
                    label="Domain URL"
                    value={formData.domain}
                    onChange={handleInputChange}
                    onBlur={() => handleErrors('domain')}
                    error={formData.domain === '' && formErrors.domain}
                    helperText={formData.domain === '' && formErrors.domain ? 'Field is required' : ''}
                  />
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  <TextField 
                    variant="outlined" 
                    fullWidth 
                    name="contactname"  
                    label="Contact Name" 
                    value={formData.contactname} 
                    onChange={handleInputChange}
                    onBlur={() => handleErrors('contactname')}
                    error={formData.contactname === '' && formErrors.contactname}
                    helperText={formData.contactname === '' && formErrors.contactname ? 'Field is required' : ''}  
                  />
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md flex " >
                <Grid item >
                  <PhoneInput 
                    fullWidth 
                    className="tellphone pos"
                    country={"india"}
                    enableSearch={true}
                    value={formData.mobile_code}
                    onChange={(country)=>setPhone(country.dialCode)}
                  />
                </Grid>
                <TextField  
                  variant="outlined"
                  label="Phone" 
                  fullWidth 
                  name="mobile_digits" 
                  value={formData.mobile_digits} 
                  onChange={handleInputChange}
                  onBlur={() => handleErrors('mobile_digits')}
                  error={(formData.mobile_digits === '' && formErrors.mobile_digits) || !!phoneError}
                  helperText={(formData.mobile_digits === '' && formErrors.mobile_digits) ? 'Field is required' : phoneError || ''}  
                />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  <TextField  
                    variant="outlined"
                    label="Email" 
                    fullWidth 
                    name="email" 
                    value={formData.email} 
                    onChange={handleInputChange}
                    onBlur={() => handleErrors('email')}
                    error={(formData.email=== '' && formErrors.email) || !!emailError}
                    helperText={(formData.email=== '' && formErrors.email) ? 'Field is required' : emailError || ''} 
                  />
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth
                  onBlur={() => handleErrors('companytype')}
                  error={formData.companytype === '' && formErrors.companytype}>
                  <InputLabel htmlFor="companytype">Company Type</InputLabel>
                  <Select
                    name="companytype"
                    value={formData.companytype}
                    onChange={handleInputChange}
                    label="Company Type"
                  >
                    <MenuItem value=""></MenuItem>
                    {companyTypesContainer.data && companyTypesContainer.data.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.companytype}
                      </MenuItem>
                    ))}
                  </Select>
                  {formData.companytype === '' && formErrors.companytype && (
                    <FormHelperText>Field is required</FormHelperText>
                  )}
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md">
                <FormControl fullWidth>
                  <CountryDropdown 
                    value={countryName}                  
                    onChange={(val) => setCountryName(val)}
                    className="country-dropdown company-screen-bg"
                  />
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  <TextField  
                    variant="outlined"
                    label="Location" 
                    fullWidth 
                    name="locate" 
                    value={formData.locate} 
                    onChange={handleInputChange}
                    onBlur={() => handleErrors('locate')}
                    error={formData.locate === '' && formErrors.locate}
                    helperText={formData.locate === '' && formErrors.locate ? 'Field is required' : ''}
                  /> 
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth
                  onBlur={() => handleErrors('currency')}
                  error={formData.currency === '' && formErrors.currency}>
                  <InputLabel htmlFor="Currency">Currency</InputLabel>
                  <Select
                    name="currency"
                    value={formData.currency}
                    onChange={handleInputChange}
                    label="Currency"
                  >
                    <MenuItem value=""></MenuItem>
                    {currenciesContainer.data && currenciesContainer.data.map((currency) => (
                      <MenuItem key={currency.id} value={currency.id}>
                        {`${currency.Code}-${currency.Currency}`}
                      </MenuItem>
                    ))}
                  </Select>
                  {formData.currency === '' && formErrors.currency && (
                    <FormHelperText>Field is required</FormHelperText>
                  )}
                </FormControl>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  <TextField  
                    variant="outlined"  
                    label="No.of Employees" 
                    fullWidth 
                    name="employesize" 
                    value={formData.employesize} 
                    onChange={handleInputChange}
                    onBlur={() => handleErrors('employesize')}
                    error={(formData.employesize=== '' && formErrors.employesize) || !!employeError}
                    helperText={(formData.employesize === '' && formErrors.employesize) ? 'Field is required' : employeError || ''} 
                  />
                </FormControl>
              </div>
              <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  {industriesContainer.data && ( 
                    <Autocomplete
                      options={industriesContainer.data}
                      getOptionLabel={(option) => option.label || ''}
                      value={industriesContainer.data.find((option) => option.id === formData.industry) || null}
                      onChange={handleAutocompleteChange}
                      renderInput={(params) => (
                        <TextField {...params} label="Industry" variant="outlined"
                          onBlur={() => handleErrors('industry')}
                          error={formData.industry === '' && formErrors.industry}
                          helperText={formData.industry === '' && formErrors.industry ? 'Field is required' : ''}
                        />
                      )}
                    />
                  )}
                </FormControl>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 pa-md " >
                <FormControl fullWidth>
                  <InputLabel htmlFor="nace"> Standard</InputLabel>
                  <Select
                    name="nace"
                    value={nacecode}
                    onChange={()=>setNaceCode('NACE')}
                    label="Standard"
                  >
                    <MenuItem value="NACE">
                      NACE
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div>
              </div>
              {heatmapContainer === "true" &&(
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md">
                  <FormControl fullWidth>
                    <InputLabel htmlFor="supplier_type">Supplier type</InputLabel>
                    <Select
                      name="supplier_type"
                      value={formData.supplier_type}
                      onChange={handleInputChange}
                      label="Supplier Type"
                    >
                      {formData.supplier_types.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              )}
              {heatmapContainer === "true" &&(
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 report-frequency">
                </div>
              )}
              {frequenciesContainer && (
                <div className="report-frequency">
                  <FormControl component="fieldset" className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <FormLabel component="legend" className="text-primary">Report frequency</FormLabel>
                    <RadioGroup
                      row
                      name="reportFrequency"
                      value={formData.reportFrequency}
                      onChange={handleInputChange} 
                    >
                      {frequenciesContainer.map((frequency) => (
                        <FormControlLabel
                          key={frequency.id}
                          value={frequency.id}
                          control={<Radio />}
                          label={frequency.label}
                          className="col-lg-3 col-sm-12 col-md-3 col-xs-12"
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </div>
              )}
              {
                  <div className='report-frequency'>
                    <div className='row'>
                      <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-0">
                        <FormLabel component="legend" className='text-primary'>
                          Web Applications
                        </FormLabel>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <Button sx={{ color: 'blue' }} onClick={handleAddField}>Add</Button>
                      </div>
                    </div>
                    {dynamicFields.map((field, index) => (
                      <div className='row' key={index}>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 p-0">
                          <TextField
                            fullWidth
                            size='small'
                            label="Web Application"
                            name='webapplications'
                            onChange={(e) => handleDynamicFieldChange(index, e.target.value)}
                          />
                        </div>
                        <div className='col-lg-1 col-md-3 col-sm-6 col-xs-6'>
                          <IconButton onClick={() => handleRemoveField(index)}>
                            <DeleteIcon sx={{ color: 'red' }} />
                          </IconButton>
                        </div>
                      </div>
                    ))}
                  </div>
                }
                {
                  <div className='report-frequency'>
                    <div className='row'>
                      <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-0">
                        <FormLabel component="legend" className='text-primary' >
                           Network Locations
                        </FormLabel>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                            <Button sx={{color:'blue'}} onClick={handleAddFieldNetwork}>Add</Button>
                      </div>
                    </div>
                    {dynamicFieldsNetwork.map((field, index) => (
                      <div className='row'>
                        <div key={index} className="col-lg-4 col-md-6 col-sm-12 col-xs-12  p-0">
                          <TextField
                            fullWidth
                            size='small'
                            label="Network"
                            name= 'Network'
                            onChange={(e) => handleDynamicFieldChangeNetwork(index, e.target.value)}
                          />
                        </div>
                        <div className='col-lg-1 col-md-3 col-sm-6 col-xs-6'>
                          <IconButton onClick={() => handleRemoveFieldNetwork(index)}>
                            <DeleteIcon sx={{ color: 'red' }} />
                          </IconButton>
                        </div>
                      </div>
                    ))}
                  </div>
                }
              {(
                    <div className="report-frequency">
                      <FormControl component="fieldset" className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <FormLabel component="legend" className="text-primary">Cloud Services</FormLabel>
                        <FormGroup row>
                          {cloudTypesContainer?.map((type) => (
                            <FormControlLabel
                              key={type?.id}
                              control={
                                <Checkbox
                                  checked={formData?.cloudtypes?.includes(type.id)}
                                  onChange={handleInputChange}
                                  name="cloudtypes"
                                  value={type.id}
                                />
                              }
                              label={type.label}
                            />
                          ))}
                        </FormGroup>
                      </FormControl>
                    </div>
                  )}
                  {
                  <div className="report-frequency">
                    <FormControl component="fieldset">
                      <FormLabel component="legend" className="text-primary">Mobile Types</FormLabel>
                      <FormGroup row>   
                        <FormControlLabel
                          key='Android'
                          control={
                            <Checkbox
                              checked={formData.mobiletypes.includes('Android')}
                              onChange={handleMobileTypesChange}
                              name="Android"
                              value="Android"
                            />
                          }
                          label="Android"
                        />
                        <FormControlLabel
                          key='IOS'
                          control={
                            <Checkbox
                              checked={formData.mobiletypes.includes('IOS')}
                              onChange={handleMobileTypesChange}
                              name="IOS"
                              value="IOS"
                            />
                          }
                          label="IOS"
                        />
                      </FormGroup>
                    </FormControl>
                  </div>
                } 
            </div>
            <div className="center-card radio-card">
              <Button variant="contained" onClick={(e) => handleSubmit(e)}>Submit</Button>
            </div>
            <p className="error-message">{errormessage}</p>
          </Card>
        </CardContent>
      </Card>
    </div>
    </div>
  );
}
export default Addcompany; 
